<template>
  <div class="text-xs-center pa-2">
    <p class="caption font-weight-thin pa-1 ma-0 grey--text text--darken-1"> {{ $options.title }} developed by <a :href="$options.poweredBy.link" target="_blank" rel="noopener" class="grey--text text--darken-1"> {{ $options.poweredBy.text }} </a></p>
  </div>
</template>

<script>

  import { title, poweredBy } from '../config/info'

  export default {
    data () {
      return {

      }
    },
    created () {
      this.$options.title = title
      this.$options.poweredBy = poweredBy
    }
  }
</script>
